module.exports = __webpack_public_path__ + "static/media/london-35.4403b288.jpg";